<template>
    <div class="app-container">
      <BjPage ref="BjPage" :label-width="'80px'" :query-params="queryParams" :selection="selection" :col-span="colSpan" :get-action="queryApi" :before-reset-search="beforeResetSearch" @handleSelectionChange="handleSelectionChange" @showSetting="SortableTable.show" @header-dragend="SortableTable.handleHeaderDragend" @afterFetchOriginalData="afterFetchOriginalData" @header-contextmenu="SortableTable.handleHeaderContextmenu">
        <template v-slot:baseForm>
          <el-col :span="colSpan">
            <el-form-item :label="$t('screenWMS.basket')" prop="basketId">
              <BjInputNumber v-model="queryParams.basketId" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('screenWMS.basket')" clearable @keyup.enter.native="handleQuery" />
            </el-form-item>
          </el-col>
          <el-col :span="colSpan">
            <el-form-item :label="$t('screenWMS.lamp')" prop="lampIndex">
              <BjInputNumber v-model="queryParams.lampIndex" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('screenWMS.lamp')" clearable @keyup.enter.native="handleQuery" />
            </el-form-item>
          </el-col>
        </template>
  
        <template v-slot:tableOperation="tableOperationProp">
          <el-col>
            <el-button type="primary" class="main-btn" @click="onAdd">{{ $t('billingPage.create') }}</el-button>
            <el-button type="primary" class="delete-btn" :disabled="tableOperationProp.notSelected" @click="onDeleteSelected">{{ $t('bulkDelText') }}</el-button>
          </el-col>
        </template>

        <template v-slot:tableColumn>
          <template v-for="(col, index) in dropCols">
            <el-table-column v-if="col.prop !== 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || false" align="center" class-name="item">
              <template slot-scope="scope">
                <template v-if="false" />
                <!-- <template v-else-if="col.prop === 'basketNumber'">
                  {{ scope.row.basketNumberStart }} - {{ scope.row.basketNumberEnd }}
                </template> -->
                <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
              </template>
            </el-table-column>
            <el-table-column v-if="col.prop === 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || 'right'" align="center">
              <template slot-scope="props">
                <el-button type="text" class="edit-btn" @click="onEdit(props.row)">{{ $t('editText') }}</el-button>
                <el-button type="text" class="delete-btn" @click="onDelete(props.row)">{{ $t('delText') }}</el-button>
              </template>
            </el-table-column>
          </template>
        </template>
      </BjPage>
      <!-- 新增/编辑弹窗 -->
      <DataForm ref="DataForm" @reFresh="reFresh"/>
    </div>
  </template>
  
  <script>
    import pageMiXin from '@/utils/page-mixin.js';
    import { waveApi } from '@/api';
    import DataForm from './DataForm.vue';

    export default {
      name: 'WMSLampRack',
      components: {DataForm,},
      mixins: [pageMiXin],
      data() {
        return {
          colSpan: 4,
          selection: true,
          queryApi: waveApi.getLampPageList,
          queryParams: {
            basketId: null,
            lampIndex: null,
          },
          labelList: [
            { label: this.$t('screenWMS.basket'), prop: 'basketId', isCheck: true, disabled: false, },
            { label: this.$t('screenWMS.lamp'), prop: 'lampIndex', isCheck: true, disabled: false, },
            { label: this.$t('screenWMS.Creator'), prop: 'creationBy', isCheck: true, disabled: false, },
            { label: this.$t('screenWMS.creation'), prop: 'creationDate', isCheck: true, disabled: false },
            { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false, width: 150 },
          ],
        };
      },
      computed: {},
      methods: {
        // 过滤页面数据
        afterFetchOriginalData(data) {
          data.content = data.records
          return data;
        },

        /** 新增灯架 */
        onAdd() {
          this.$refs.DataForm.show();
        },

        /** 编辑灯架 */ 
        onEdit(row) {
          this.$refs.DataForm.show(row);
        },

        // 删除灯架
        onDelete(row) {
          this.$confirm(this.$t('InternalSalesOrderDetails.want'), this.$t('toast.hintText'), {
            confirmButtonText: this.$t('toast.okText'),
            cancelButtonText: this.$t('toast.cancelText'),
            type: 'warning',
          })
            .then(() => {
              waveApi.delLampPageList({ids: [row.id], lastUpdateBy: this.$store.getters.userInfo.realName }).then(res => {
                if (res.code == 200) {
                  this.$message.success(this.$t('toast.operationSuccessText'));
                  setTimeout(() => {
                    this.reFresh();
                  }, 500);
                }else{
                  this.$message.error(res.msg);
                }
              });
            })
            .catch(() => {});
        },

        /** 批量删除操作 */
        onDeleteSelected() {
          if (!this.selectedRows.length) {
            this.$message.warning(this.$t('chooseText'));
            return;
          }
          const ids = this.selectedRows.map(e => e.id);
          this.$confirm(this.$t('toast.delAllTipText'), this.$t('toast.hintText'), {
            confirmButtonText: this.$t('toast.okText'),
            cancelButtonText: this.$t('toast.cancelText'),
            type: 'warning',
          })
            .then(() => {
              waveApi.delLampPageList({ids: ids, lastUpdateBy: this.$store.getters.userInfo.realName }).then(res => {
                if (res.code == 200) {
                  this.$message.success(this.$t('toast.operationSuccessText'));
                  setTimeout(() => {
                    this.reFresh();
                  }, 500);
                }else{
                  this.$message.error(res.msg);
                }
              });
            })
            .catch(() => {});
        },

        beforeResetSearch() {
          this.queryParams.basketId = null;
          this.queryParams.lampIndex = null;
          return new Promise(resolve => {
            resolve();
          });
        },
      },
    };
  </script>
  <style lang="scss" scoped>
  .el-icon-s-flag {
    float: right;
    line-height: 34px;
  }
  </style>
  